import Modal from 'react-bootstrap/Modal';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { useState } from "react";
import { selectOrder, deleteDraftOrder } from '../../reducers/order-details-slice';
import { selectActiveFormExistingOrder } from "../../reducers/active-form-slice";
import { BeatLoader } from 'react-spinners';


const ConfirmCancelModal = ({ showConfirmCancelModal, handleHideConfirmCancelModal, handleShowSubmissionFailureModal, handleResetFormValues }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const order = useSelector(selectOrder);
    const isExistingOrder = useSelector(selectActiveFormExistingOrder);
    const [loading, setLoading] = useState(false);

    const handleConfirmCancelClick = async () => {
        setLoading(true);
        var response = null;
        if (isExistingOrder) {
            response = await dispatch(deleteDraftOrder(order.id));
            setLoading(false);

            if (!response.payload) {
                handleHideConfirmCancelModal();
                handleShowSubmissionFailureModal();
            }
        }

        if (!isExistingOrder || response.payload) {
            await handleResetFormValues();
            setLoading(false);
            navigate('/');
        }
    };

    return (
        <Modal
            backdrop="static"
            show={showConfirmCancelModal}
            onHide={handleHideConfirmCancelModal}
            centered
        >
            {loading && <div className="loader-container"><BeatLoader color="#00818C" /></div>}

            <Modal.Header closeButton>
                <Modal.Title>Cancel Order</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {isExistingOrder ?
                    <div className="form-field-wrapper">
                        This order will be deleted and you will be taken to your home dashboard. Do you wish to continue?
                    </div> :
                    <div className="form-field-wrapper">
                        No order info will be saved and you will be taken to your home dashboard. Do you wish to continue?
                    </div>
                }
            </Modal.Body>

            <Modal.Footer>
                <button type="button" className="button cancel-order" onClick={handleHideConfirmCancelModal}>No</button>
                <button type="submit" className="button tertiary cancel-order" onClick={handleConfirmCancelClick}>Yes</button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmCancelModal;